'use client';
import MuiBox from '@new-components/atoms/MuiBox';
import MuiTypography from '@new-components/atoms/MuiTypography';
import NumericMultiCheckButton from '@new-components/atoms/NumericMultiCheckButton';
import React from 'react';

type Props = {
  title: string;
  subTitle: string;
  options: Record<'label' | 'value', string>[];
  value: string[];
  handleChange: (value: string[]) => void;
};
const BedroomAdvanceFilter = (props: Props) => {
  return (
    <MuiBox sx={{display: 'flex', flexDirection: 'column', width: '100%'}}>
      <MuiBox
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
          marginBottom: '24px',
        }}>
        <MuiTypography
          sx={{
            fontSize: '17px',
            fontWeight: 500,
            letterSpacing: '-0.4px',
            color: '#000000',
          }}>
          {props.title}
        </MuiTypography>
        <MuiTypography
          sx={{
            height: '16px',
            fontSize: '13px',
            fontWeight: 400,
            letterSpacing: '-0.4px',
            color: '#82807EB2',
          }}>
          {props.subTitle}
        </MuiTypography>
      </MuiBox>
      <NumericMultiCheckButton
        options={props.options}
        onSelectionChange={props.handleChange}
        checkedOptions={props.value}
      />
    </MuiBox>
  );
};

export default BedroomAdvanceFilter;
